<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.Overall_statistics") }}</h5>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <div class="statics mt-4">
        <div class="row">
          <!-- Total App Members -->
          <div class="col-lg-6 col-md-6 col-12">
            <div class="box clickable" @click="navigateTo('/Clients/all')">
              <div class="icon">
                <i class="fas fa-users"></i>
              </div>
              <div class="info_box">
                <span>{{ $t("STATISTICS.total_app_members") }}</span>
                <p class="number_box">{{ statics.users || 0 }}</p>
              </div>
            </div>
          </div>

          <!-- Total Published Ads -->
          <div class="col-lg-6 col-md-6 col-12">
            <div
              class="box clickable"
              @click="navigateTo('/advertisements/all?is_blocked=false')"
            >
              <div class="icon">
                <i class="fas fa-bullhorn"></i>
              </div>
              <div class="info_box">
                <span>{{ $t("STATISTICS.total_published_ads") }}</span>
                <p class="number_box">{{ statics.ads || 0 }}</p>
              </div>
            </div>
          </div>

          <!-- Available Packages -->
          <div class="col-lg-6 col-md-6 col-12">
            <div class="box clickable" @click="navigateTo('/packages/all')">
              <div class="icon">
                <i class="fas fa-box"></i>
              </div>
              <div class="info_box">
                <span>{{ $t("STATISTICS.available_packages") }}</span>
                <p class="number_box">{{ statics.packages || 0 }}</p>
              </div>
            </div>
          </div>

          <!-- Total Packages Subscription Price -->
          <div class="col-lg-6 col-md-6 col-12">
            <div
              class="box clickable"
              @click="navigateTo('/financial-packages/all')"
            >
              <div class="icon">
                <i class="fas fa-money-bill-wave"></i>
              </div>
              <div class="info_box">
                <span>{{ $t("STATISTICS.total_subscriptions_price") }}</span>
                <p class="number_box">
                  {{ formatPrice(statics.subscriptions) }}
                </p>
              </div>
            </div>
          </div>

          <!-- Total App Profit -->
          <div class="col-lg-6 col-md-6 col-12">
            <div class="box clickable">
              <div class="icon">
                <i class="fas fa-chart-line"></i>
              </div>
              <div class="info_box">
                <span>{{ $t("STATISTICS.total_app_profit") }}</span>
                <p class="number_box">
                  {{ formatPrice(statics.total_earning) }}
                </p>
              </div>
            </div>
          </div>

          <!-- Total Admins -->
          <div class="col-lg-6 col-md-6 col-12">
            <div class="box clickable" @click="navigateTo('/admins/all')">
              <div class="icon">
                <i class="fas fa-user-shield"></i>
              </div>
              <div class="info_box">
                <span>{{ $t("STATISTICS.total_admins") }}</span>
                <p class="number_box">{{ statics.admins || 0 }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->
  </div>
</template>

<script>
import ComingSoon from "@/components/ui/ComingSoon.vue";

export default {
  name: "HomePage",

  components: {
    ComingSoon,
  },

  data() {
    return {
      statics: {
        users: 0,
        admins: 0,
        packages: 0,
        ads: 0,
        subscriptions: 0,
        total_earning: 0,
      },
    };
  },

  methods: {
    async getStatics() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "statistic",
        });

        this.statics = res.data.data;
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    },

    formatPrice(value) {
      if (!value && value !== 0) return "0 " + this.$t("PLACEHOLDERS.riyal");
      const numValue = typeof value === "string" ? parseFloat(value) : value;
      return numValue.toFixed(2) + " " + this.$t("PLACEHOLDERS.riyal");
    },

    navigateTo(route) {
      this.$router.push(route);
    },
  },

  mounted() {
    this.getStatics();
  },
};
</script>

<style lang="scss" scoped>
.show_all_content_wrapper {
  .statics {
    .box {
      background: #008274;
      padding: 25px;
      margin-bottom: 10px;
      border-radius: 5px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;

      transition: all 0.5s;

      &.clickable {
        cursor: pointer;
      }

      &:hover {
        background: #fff;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        transform: translateY(-5px);

        .icon {
          i {
            color: #008274;
          }
        }
        .info_box {
          span,
          p.number_box {
            color: #000;
          }
        }
      }

      .icon {
        height: 60px;
        min-width: 60px;
        width: 60px;
        border-radius: 60px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 25px;
          color: #000;
        }
      }

      .info_box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;

        span {
          font-size: 19px;
          color: #fff;
        }

        p.number_box {
          font-size: 30px;
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
}
.show_all_content_wrapper .statics .box .info_box {
  align-items: flex-start !important;
  width: 100% !important;
  padding-inline-start: 5% !important;
}
</style>
